var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 176,
    height: 48,
    viewBox: "0 0 176 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -54.488,
    y1: 11.191,
    x2: -54.494,
    y2: 11.189,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -71.273,
    y1: 28.517,
    x2: -71.287,
    y2: 28.517,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -42.288,
    y1: 19.826,
    x2: -42.293,
    y2: 19.818,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -42.72,
    y1: 21.528,
    x2: -42.718,
    y2: 21.525,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-908 -8012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.096 7309.147)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 48,
    rx: 4,
    transform: "translate(871.904 702.852)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M934.815,715.63a3.344,3.344,0,0,1-.86,2.455,3.818,3.818,0,1,1-2.7-6.5,3.265,3.265,0,0,1,1.466.366,2.67,2.67,0,0,1,1.1.861l-.614.612a2.292,2.292,0,0,0-1.963-.86,2.451,2.451,0,0,0-1.964.86,2.965,2.965,0,0,0,0,4.171,3.159,3.159,0,0,0,1.964.859,2.691,2.691,0,0,0,2.086-.859,2.036,2.036,0,0,0,.612-1.467h-2.7v-.982h3.557v.492Zm5.644-3.066h-3.313V714.9h3.066v.86h-3.066v2.33h3.313v.982h-4.294v-7.363h4.294Zm4.05,6.5h-.982v-6.512h-2.085V711.7H946.6v.859h-2.085Zm5.643,0v-7.363h.982v7.363Zm5.154,0h-.982v-6.512h-2.086V711.7h5.032v.859h-2.086v6.5Zm11.656-.982a3.849,3.849,0,1,1,1.106-2.7,3.6,3.6,0,0,1-1.106,2.7Zm-4.666-.612a2.9,2.9,0,0,0,1.964.858,2.443,2.443,0,0,0,1.964-.858,2.964,2.964,0,0,0,.859-2.086,2.536,2.536,0,0,0-.859-2.087,2.9,2.9,0,0,0-1.964-.858,2.442,2.442,0,0,0-1.964.858,2.962,2.962,0,0,0-.86,2.087,2.529,2.529,0,0,0,.865,2.085Zm7.116,1.6v-7.363h1.1l3.558,5.768v-5.768h.981v7.363h-.981l-3.8-6.013v6.013Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.267
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M960.216,729.865a5.162,5.162,0,0,0-5.276,5.047c0,.077,0,.154,0,.23a5.236,5.236,0,0,0,5.2,5.276h.078a5.162,5.162,0,0,0,5.277-5.045q0-.115,0-.231a5.09,5.09,0,0,0-4.9-5.277C960.47,729.861,960.343,729.861,960.216,729.865Zm0,8.343a3.2,3.2,0,0,1,0-6.381,2.973,2.973,0,0,1,2.951,2.995c0,.066,0,.132-.007.2a3.047,3.047,0,0,1-2.9,3.188l-.048,0ZM948.8,729.865a5.164,5.164,0,0,0-5.278,5.046q0,.115,0,.231a5.237,5.237,0,0,0,5.2,5.276h.079a5.161,5.161,0,0,0,5.276-5.046c0-.077,0-.153,0-.23a5.09,5.09,0,0,0-4.9-5.277c-.126,0-.252,0-.379,0Zm0,8.343a3.2,3.2,0,0,1,0-6.381,2.974,2.974,0,0,1,2.952,2.995c0,.066,0,.132-.008.2a3.046,3.046,0,0,1-2.9,3.188l-.048,0Zm-13.62-6.748v2.207h5.276a4.636,4.636,0,0,1-1.225,2.824,5.436,5.436,0,0,1-4.05,1.6,5.714,5.714,0,0,1-5.769-5.657c0-.078,0-.155,0-.233a5.787,5.787,0,0,1,5.685-5.887h.082a6.087,6.087,0,0,1,4.05,1.6l1.6-1.6a7.861,7.861,0,0,0-5.521-2.211,8.1,8.1,0,1,0-.3,16.2c.1,0,.2,0,.3,0a7.062,7.062,0,0,0,5.642-2.334,7.378,7.378,0,0,0,1.964-5.153,4.612,4.612,0,0,0-.122-1.35Zm55.706,1.718a4.766,4.766,0,0,0-4.417-3.313,4.94,4.94,0,0,0-4.919,4.963c0,.1,0,.21.011.314a5.136,5.136,0,0,0,4.991,5.275h.163a5.027,5.027,0,0,0,4.294-2.332L989.3,736.86a2.993,2.993,0,0,1-2.577,1.467,2.667,2.667,0,0,1-2.577-1.6l6.994-2.944-.246-.612Zm-7.117,1.716a2.982,2.982,0,0,1,2.7-3.066,2.173,2.173,0,0,1,1.964,1.1l-4.666,1.963Zm-5.765,5.031h2.33V724.592h-2.33Zm-3.682-8.957a4.048,4.048,0,0,0-2.823-1.225,5.271,5.271,0,0,0-5.029,5.277,5.082,5.082,0,0,0,5.008,5.154h.021a3.527,3.527,0,0,0,2.7-1.227h.121v.736a2.789,2.789,0,0,1-5.4,1.226l-1.963.86a5.067,5.067,0,0,0,4.667,3.067c2.7,0,4.908-1.6,4.908-5.4v-9.325h-2.211v.859Zm-2.7,7.24a3.214,3.214,0,1,1,2.794-2.793A3.2,3.2,0,0,1,971.628,738.208Zm29.939-13.618h-5.521v15.333h2.332v-5.769h3.189a4.791,4.791,0,1,0,.446-9.571c-.149-.007-.3-.007-.446,0Zm.121,7.361H998.38v-5.276h3.31a2.7,2.7,0,0,1,2.7,2.577,2.8,2.8,0,0,1-2.7,2.7Zm14.111-2.208a4.12,4.12,0,0,0-4.048,2.332l2.085.858a2.168,2.168,0,0,1,2.085-1.1,2.3,2.3,0,0,1,2.453,1.964v.122a4.854,4.854,0,0,0-2.329-.612c-2.21,0-4.419,1.226-4.419,3.435a3.6,3.6,0,0,0,3.755,3.439c.017,0,.034,0,.051,0a3.444,3.444,0,0,0,2.942-1.466h.124v1.226h2.208v-5.889a4.643,4.643,0,0,0-4.908-4.295Zm-.246,8.466c-.735,0-1.838-.367-1.838-1.35,0-1.226,1.35-1.6,2.453-1.6a4.744,4.744,0,0,1,2.085.492,2.857,2.857,0,0,1-2.7,2.458Zm12.886-8.1-2.578,6.626h-.122l-2.7-6.626h-2.454l4.05,9.326-2.331,5.155h2.331l6.258-14.479Zm-20.615,9.816h2.332V724.594h-2.332Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M889.417,712.317a2.4,2.4,0,0,0-.491,1.719v27.116a2.434,2.434,0,0,0,.614,1.719l.122.122,15.215-15.216v-.244Z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M909.786,732.931l-5.03-5.03v-.367l5.03-5.03.123.122,6.013,3.436c1.719.981,1.719,2.576,0,3.557Z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M909.909,732.81l-5.154-5.155-15.333,15.333c.613.613,1.467.613,2.577.122l17.915-10.3",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M909.909,722.5l-17.915-10.184a1.987,1.987,0,0,0-2.577.121l15.333,15.216L909.9,722.5Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.786,732.688l-17.792,10.061a2,2,0,0,1-2.453,0l-.124.122.124.122a2,2,0,0,0,2.453,0Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.417,742.748a2.4,2.4,0,0,1-.491-1.718v.121a2.431,2.431,0,0,0,.614,1.718v-.121Zm26.5-13.5-6.133,3.436.122.124,6.013-3.438a2.034,2.034,0,0,0,1.225-1.719C917.146,728.269,916.654,728.76,915.921,729.25Z",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.988,712.441l23.927,13.62c.736.492,1.226.981,1.226,1.6a2.043,2.043,0,0,0-1.226-1.719l-23.927-13.618c-1.717-.981-3.067-.247-3.067,1.717v.123C888.921,712.319,890.277,711.459,891.988,712.441Z",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaystore);
export default __webpack_public_path__ + "static/media/icon-playstore.e634ff90e352d618faecb2d097848a8d.svg";
export { ForwardRef as ReactComponent };